import { GroupedBasketItemTypes } from '@common/components/ItemListingRows/ItemListingRows';
import moment from 'moment';
import { BasketDrawerTextWrapper, BasketItemText, Listing } from '../BasketDrawer.styles';

export const FulfilablesListing = ({
  fulfilables,
}: {
  fulfilables: GroupedBasketItemTypes['events'] | GroupedBasketItemTypes['vouchers'];
}) => {
  return (
    <Listing>
      {fulfilables?.map((fulfilable) => {
        return (
          <div data-testid="fulfilables-listing" key={fulfilable.id}>
            {fulfilable.event && (
              <BasketDrawerTextWrapper>
                {moment(fulfilable.event.dateTime).format('ddd, D MMM')}
              </BasketDrawerTextWrapper>
            )}
            <BasketDrawerTextWrapper>
              <BasketItemText>{fulfilable.detailsBag.name}</BasketItemText>
            </BasketDrawerTextWrapper>
          </div>
        );
      })}
    </Listing>
  );
};
